// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"carousel-controls_wrapper__1sMl3"};